<template>
  <div class="list-page">
    <crumbs title="用户管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="3">
          <enumerate
            url="/api/user/usertypeenum"
            v-model="queryCondition.cerType"
            placeholder="认证类型"
          />
        </el-col>
        <el-col :span="3">
          <enumerate
            url="/api/user/certypeenum"
            v-model="queryCondition.certificateStatus"
            placeholder="认证状态"
          />
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="queryCondition.createDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="注册时间"
            end-placeholder="注册时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="queryCondition.phoneNumber"
            clearable
            placeholder="手机号"
          >
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="queryCondition.account"
            clearable
            placeholder="账号昵称"
          >
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="queryCondition.userId"
            clearable
            placeholder="用户ID"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="createUserDialog = true"
        >添加用户</el-button
      >
      <!-- <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除用户</el-button
      > -->
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="account"
          label="账号昵称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cerTypeName"
          label="认证类型"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditName"
          label="认证状态"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column label="注册时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="handleAduit(scope.row)"
              >审核</el-button
            >
            <el-button size="mini" type="info" @click="handleLook(scope.row)"
              >查看</el-button
            >
            <!-- <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <add-user
      v-if="createUserDialog"
      @close="createUserDialog = false"
      @complete="completetCreateUser"
    />
  </div>
</template>

<script>
export default {
  name: "userContentlist",
  data() {
    return {
      //查询条件
      queryCondition: {
        cerType: "",
        certificateStatus: "",
        createDate: [],
        phoneNumber: "",
        account: "",
        userId: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: [],
      // 添加用户弹框
      createUserDialog: false
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    // 完成添加用户
    completetCreateUser() {
      this.createUserDialog = false;
      this.loadList();
    },
    //出来参数
    processParams() {
      let { createDate, ...other } = this.queryCondition,
        mixin = {
          cerType: "",
          certificateStatus: ""
        },
        [createStart = "", createEnd = ""] = createDate || [];
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        ...other,
        ...mixin,
        createStart,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("user", "getList", this.processParams()).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击审核
    handleAduit(row) {
      const { id, cerType } = row;
      this.redirectByPath(
        `/admin/userManage/${
          cerType === "2" ? "userComCerInfo" : "userPerCerInfo"
        }`,
        {
          id
        },
        this.queryCondition
      );
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.$api("user", "batchDelete", idList).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击查看
    handleLook(row) {
      const { id, cerType } = row;
      this.redirectByPath(
        `/admin/userManage/userContentInfo/${cerType === "2" ? "com" : "per"}`,
        {
          id
        },
        this.queryCondition
      );
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
